const data = {};

data.otp = {
  data: {
    code: 0,
    message: 'success',
    data: {
      registered: true,
    },
  },
};

data.authData = {
  data: {
    code: 0,
    message: 'success',
    // data: null,
    data: {
      status: '承認済',
      nexonSN: 123,
      // 신청유형
      creatorType: '法人',
      companyName: '株式会社ネクソン',
      // 사업자번호
      invoiceRegistNumber: '123456',
      email: 'user@example.com',
      tellNumber: '010-1111-5555',
      birthday: '1994/05/06',
      firstName: '秀賢',
      familyName: '朴',
      firstNameKana: 'ヤマダ',
      familyNameKana: 'タロウ',
      postCode: '332-0011',
      prefecture: '北海道',
      address: '港区六本木１丁目',
      buildingName: 'アークヒルズサウスタワー',
    },
  },
};

data.registerAuthDataRes = {
  data: {
    // code: -1,
    code: 0,
    message: 'error message',
    data: null,
  },
};

data.editAuthDataRes = {
  data: {
    code: 0,
    message: 'success',
    data: null,
  },
};

data.fileList = {
  data: {
    code: 0,
    message: 'success',
    data: {
      uploadList: [
        {
          sn: 1,
          fileName: 'file name1',
          fileBin: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
          regDate: 'yyyy-MM-ddT00:39:40.552Z',
        },
        {
          sn: 2,
          fileName: 'file name2',
          fileBin: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
          regDate: 'yyyy-MM-ddT00:39:40.552Z',
        },
      ],
    },
  },
};

data.uploadFilesRes = {
  data: {
    code: 0,
    message: 'success',
    data: null,
  },
};

export default {
  ...data,
};
